import { omit, Omit } from 'lodash';
import Watermark from './Watermark';

export type SessionData = Omit<Session, 'id' | 'data'>;

export default class Session {
    public watermark: Watermark | null;
    public pricelistId: string | null;
    public welcomeMessageSetId: string | null;
    public waitingForWatermark = false;
    constructor(
        readonly id: string,
        readonly name: string,
        watermark?: Watermark|null,
        pricelistId?: string|null,
        public finalizationEnabled = false,
        public downloadEnabled = false,
        public finalized = false,
        public finalizationMode = false,
        public orderCount = 0,
        public chatEnabled = false,
        welcomeMessageSetId: string | null = null,
    ) {
        this.watermark = watermark || null;
        this.pricelistId = pricelistId || null;
        this.welcomeMessageSetId = welcomeMessageSetId;
    }
    get data(): SessionData {
        return omit<Session, 'id' | 'data'>(this, 'id', 'data');
    }
}
